import { jsxs as n, Fragment as f, jsx as e } from "react/jsx-runtime";
import { CurrencyBadge as p } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as i } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as l } from "../../../../../providers/use-locale-provider.mjs";
import { calculateShippingTax as d } from "../../utils/calculate-shipping.mjs";
import { useTranslation as u, centsToUnits as c } from "@systemeio/ui";
const _ = ({
  product: x,
  selectedShipping: s,
  calculatePrice: r
}) => {
  var a;
  const { locale: t } = l(), { t: m } = u(), o = d(s, (a = r == null ? void 0 : r.tax) == null ? void 0 : a.rate);
  return /* @__PURE__ */ n(f, { children: [
    /* @__PURE__ */ e("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
    /* @__PURE__ */ n("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ e("span", { className: "text-[14px]", children: m("public_pages_purchase.shipping_fee") }),
      /* @__PURE__ */ n("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ e(p, { currency: s.currency }),
        /* @__PURE__ */ e("span", { className: "text-[14px] font-semibold", children: i(
          c(s.price),
          x.currency,
          t
        ) })
      ] })
    ] }),
    o > 0 && /* @__PURE__ */ n("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ e("span", { className: "text-[14px]", children: m("public_pages_purchase.vat_percent", {
        percent: r == null ? void 0 : r.tax.rate
      }) }),
      /* @__PURE__ */ n("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ e(p, { currency: s.currency }),
        /* @__PURE__ */ e("span", { className: "text-[14px] font-semibold", children: i(
          c(o),
          s.currency,
          t
        ) })
      ] })
    ] })
  ] });
};
export {
  _ as ShippingSummary
};
